<template>
  <div class="menu-item-r">
    <div class="dash-form-container">
      <el-form
        :model="form"
        :rules="rules"
        ref="companyForm"
        size="small"
        label-width="130px"
        v-if="(list.length > 0 || uploadList.length > 0) && companyInfo">
        <el-row>
          <div v-for="item in uploadList" :key="item.id" :class="item.keyword" class="form-block" style="padding-top: 30px;">
            <div class="utils-title" v-if="item.keyword == 'logoImage'">
              {{ item.name || $t('Upload logo') }}
            </div>
            <div class="utils-title" v-if="item.keyword == 'advertsImage'">
              {{ item.name || $t('Upload picture2') }}
              <div class="utils-subTitle">
                <div class="t">{{$t('companyInfo.companyTip')}}</div>
                <div class='t2'>{{$t('companyInfo.companyTip2')}}</div>
              </div>
            </div>
            <div class="utils-title" v-if="item.keyword == 'advertsVideo'">
              {{ item.name || $t('Upload video') }}
              <div class="utils-subTitle">
                <div class="t">{{$t('companyInfo.companyTip7')}}</div>
                <div class='t2'>{{$t('companyInfo.companyTip8')}}</div>
              </div>
            </div>
            <el-form-item
              v-if="uploadText.indexOf(item.keyword) > -1"
              label-width="0"
              class="m-b-0"
              :prop="item.keyword">
              <template v-if="item.keyword == 'logoImage'">
                <div class="image-list image-list-start">
                  <div class="tip-block-example">
                    <div class="icondiv  iconLogo">
                      <div>
                          <div class="tips font-size-12">
                            <template v-if="language == 'en'">
                              <img :src="imgList.tipsEn" />
                            </template>
                            <template v-else>
                              <img :src="imgList.tips" />
                            </template>
                          </div>
                      </div>
                      <div class="flex flex-start">
                        <div class="iconTips">
                          <div>
                            <img :src="imgList.logo" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="separate"></div>
                    <div class="flex flex-start">
                      <div class="warning font-size-12 utils-tips"><i class="el-icon-warning"></i>{{ $t('exhformTisp') }}</div>
                      <div>
                        <p class="utils-tips font-size-12 warning">1.{{ $t('companyInfo.companyTip10') }}</p>
                        <p class="utils-tips font-size-12 warning">2.{{ $t('companyInfo.companyTip11') }}</p>
                        <p class="utils-tips font-size-12 warning">3.{{ $t('companyInfo.companyTip13') }}</p>
                      </div>
                    </div>
                    
                    <div class="image-list1">
                      <div class="button-group">
                        <el-button
                          type="primary"
                          size="mini"
                          icon="el-icon-circle-plus-outline"
                          :disabled="form[item.keyword].length >= 1"
                          @click="uploadFile('logoImage')"
                          >{{ $t('Upload picture') }}</el-button
                        >
                      </div>
                      <div class="upload-image-container" :class="{'margin-t-24': form[item.keyword].length > 0}">
                        <DashUploadMore ref="logoImage" size="small" :uploadBtn="false" :limit="1" :mediaUrl.sync="form[item.keyword]"></DashUploadMore>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <DashUpload
                  :tips="$t('Only support png & jpg, less than 1Mb 350px')"
                  :size="'square'"
                  :layout="'right'"
                  :disabled="!item.editable"
                  :mediaUrl.sync="form[item.keyword]"
                /> -->
              </template>
              <template v-if="item.keyword == 'advertsImage'">
                <div class="image-list image-list-start">
                  <div class="tip-block-example">
                    <div class="icondiv">
                      <div>
                          <h4 class="h4 font-size-12">{{ $t('companyInfo.companyTip3') }}</h4>
                          <div class="tips font-size-12">
                            <template v-if="language == 'en'">
                              <img :src="imgList.tipsEn" />
                            </template>
                            <template v-else>
                              <img :src="imgList.tips" />
                            </template>
                          </div>
                      </div>
                      <div class="flex flex-start">
                        <div class="iconTips">
                          <div>
                            <img :src="imgList.companyTips1" />
                          </div>
                          <div class="margin-t-12 utils-tips2 h5 font-size-12">{{ $t('companyInfo.companyTip4') }}</div>
                        </div>
                        <div class="iconTips">
                          <div>
                            <img :src="imgList.companyTips2" />
                          </div>
                          <div class="margin-t-12 utils-tips2 h5 font-size-12">{{ $t('companyInfo.companyTip5') }}</div>
                        </div>
                        <div class="iconTips">
                          <div>
                            <img :src="imgList.companyTips3" />
                          </div>
                          <div class="margin-t-12 utils-tips2 h5 font-size-12">{{ $t('companyInfo.companyTip6') }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="separate"></div>
                    <div class="flex flex-start">
                      <div class="warning font-size-12 utils-tips"><i class="el-icon-warning"></i>{{ $t('exhformTisp') }}</div>
                      <div>
                        <p class="utils-tips font-size-12 warning">1.{{ $t('companyInfo.uploadTip') }}</p>
                        <p class="utils-tips font-size-12 warning">2.{{ $t('companyInfo.uploadTip2') }}</p>
                      </div>
                    </div>
                    
                    <div class="image-list1">
                      <div class="button-group">
                        <el-button
                          type="primary"
                          size="mini"
                          icon="el-icon-circle-plus-outline"
                          :disabled="form[item.keyword].length >= 10"
                          @click="uploadFile('uploadImg')"
                          >{{ $t('Upload picture3') }}</el-button
                        >
                      </div>
                      <div class="upload-image-container" :class="{'margin-t-24': form[item.keyword].length > 0}">
                        <!-- <DashUploadMore 
                          ref="uploadImg" 
                          size="long" 
                          :accept="'*.doc,'"
                          :uploadBtn="false" 
                          :limit="1" 
                          :mediaUrl.sync="form[item.keyword]">
                        </DashUploadMore> -->
                        <DashUploadMore ref="uploadImg" size="long" :uploadBtn="false" :limit="10" :mediaUrl.sync="form[item.keyword]"></DashUploadMore>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="item.keyword == 'advertsVideo'">
                <div class="tip-block-example">
                    <div class="flex flex-start align-start">
                      <div class="icondiv video">
                        <div>
                            <div class="tips font-size-12">
                              <template v-if="language == 'en'">
                                <img :src="imgList.tipsEn" />
                              </template>
                              <template v-else>
                                <img :src="imgList.tips" />
                              </template>
                            </div>
                        </div>
                        <div class="iconTips">
                          <div>
                            <img :src="imgList.companyTips4" />
                          </div>
                        </div>
                      </div>
                      <div class="icondiv video">
                        <div>
                            <div class="tips font-size-12">
                              <template v-if="language == 'en'">
                                <img :src="imgList.tipsEn" />
                              </template>
                              <template v-else>
                                <img :src="imgList.tips" />
                              </template>
                            </div>
                        </div>
                        <div class="iconTips">
                          <div>
                            <img :src="imgList.companyTips5" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="separate"></div>
                    <div class="flex flex-start">
                      <div class="warning font-size-12 utils-tips"><i class="el-icon-warning"></i>{{ $t('exhformTisp') }}</div>
                      <div>
                        <p class="utils-tips font-size-12 warning">{{ $t('exhformTisp15') }}</p>
                        <p class="utils-tips font-size-12 warning">{{ $t('exhformTisp16') }}</p>
                        <p class="utils-tips font-size-12 warning">3.{{ $t('companyInfo.uploadTip3') }}</p>
                      </div>
                    </div>
                    <div class="button-group">
                      <el-button
                        :type="uploadFileStatus == 1 ? 'primary' : ''"
                        size="mini"
                        icon="el-icon-circle-plus-outline"
                        @click="uploadFile('uploadVideo', 1)"
                        >{{ $t('Upload video') }}</el-button
                      >
                      <el-button
                        :type="uploadFileStatus == 2 ? 'primary' : ''"
                        size="mini"
                        icon="el-icon-circle-plus-outline"
                        @click="uploadFile('uploadPreviewImage', 2)"
                        >{{ $t('finds.uploadVideoImg') }}</el-button
                      >
                    </div>
                    <div class="upload-image-container" :class="{'margin-t-24': (form['advertsVideo'].length > 0 && uploadFileStatus == 1) || (form['advertsVideoImage'].length>0 && uploadFileStatus == 2) }">
                      <DashUploadMore
                        ref="uploadVideo"
                        v-show="uploadFileStatus === 1"
                        size="long2"
                        :limit="1"
                        :media="'video'"
                        :uploadBtn="false"
                        :mediaUrl.sync="form[item.keyword]"
                      ></DashUploadMore>

                      <DashUploadMore
                        ref="uploadPreviewImage"
                        v-show="uploadFileStatus === 2"
                        size="long2"
                        :limit="1"
                        :uploadBtn="false"
                        :mediaUrl.sync="form['advertsVideoImage']"
                      ></DashUploadMore>
                    </div>
                </div>
                <!-- <DashUpload
                  :media="'video'"
                  :layout="'right'"
                  :size="'small'"
                  :disabled="!item.editable"
                  :advertsVideoImage.sync="form['advertsVideoImage']"
                  :mediaUrl.sync="form[item.keyword]"
                /> -->
              </template>
            </el-form-item>
            <!-- <template v-if="item.keyword == 'advertsVideo'">
              <div class="utils-title">
                {{ $t('finds.uploadVideoImg') }}
              </div>
              <el-form-item
                label-width="0"
                class="m-b-0"
                prop="advertsVideoImage">
                <DashUpload
                  :size="'small'"
                  :layout="'right'"
                  :disabled="!item.editable"
                  :mediaUrl.sync="form['advertsVideoImage']"/>
              </el-form-item> 
            </template> -->
          </div>
        </el-row>
        <el-row>
          <div class="form-block v-clearfix">
            <div class="utils-title" >
              {{ $t('Add form data') }}
            </div>
            <!-- 字段1组 -->
            <template v-for="(item) in list">
              <template v-if="fields1.indexOf(item.keyword) > -1">
                <div :key="item.id">
                  <el-col :xs="24" :sm="24" :md="24" v-if="$config.form.textareaFields.indexOf(item.keyword) > -1">
                    <el-form-item
                      :label="item.name"
                      :prop="item.keyword">
                      <el-input
                        type="textarea"
                        rows="4"
                        :placeholder="item.placeholder"
                        :disabled="!item.editable"
                        v-model="form[item.keyword]"
                        :maxlength="item.inputLength || 200"
                        show-word-limit
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col v-else :xs="24" :sm="12" :md="12">
                    <el-form-item
                      :label="item.name"
                      v-if="uploadText.indexOf(item.keyword) == -1 && countryArea.indexOf(item.keyword) == -1"
                      :prop="item.keyword">
                      <template v-if="item.canSelect">
                        <el-select
                          v-if="item.keyword == 'listed'"
                          v-model="form[item.keyword]"
                          :placeholder="item.placeholder"
                          :disabled="!item.editable"
                        >
                          <el-option v-for="item in listedList" :value="item.value" :label="item.label" :key="item.value"></el-option>
                        </el-select>
                        <el-select
                          v-else
                          v-model="form[item.keyword]"
                          :disabled="!item.editable"
                          :placeholder="item.placeholder"
                        ></el-select>
                      </template>
                      <template v-if="!item.canSelect">
                        <el-input
                          :placeholder="item.placeholder"
                          :disabled="!item.editable"
                          v-model="form[item.keyword]"
                          :maxlength="item.inputLength || 200"
                          :class="{'input-with-select': $config.form.httpFields.indexOf(item.keyword) > -1}"
                          show-word-limit>
                          <el-select v-model="form[item.keyword+'_http']" slot="prepend" v-if="$config.form.httpFields.indexOf(item.keyword) > -1">
                            <el-option v-for="item in $t('select.httpOptions')" :key="item.label" :value="item.value"></el-option>
                          </el-select>
                          <template slot="prepend" v-if="$config.form.phoneCodeFields.indexOf(item.keyword) > -1 && form.countryCode">{{form.countryCode}}</template>
                          <template slot="prepend" v-if="$config.form.cityPhoneCodeFields.indexOf(item.keyword) > -1 && phoneCode"> - </template>
                          <template slot="prepend" v-if="$config.form.cityPhoneCodeFields.indexOf(item.keyword) > -1 && phoneCode">{{phoneCode}}</template>
                        </el-input>
                      </template>
                    </el-form-item>
                    <template v-if="uploadText.indexOf(item.keyword) == -1">
                      <el-form-item
                        :label="item.name"
                        v-if="item.keyword == 'countryName'"
                        prop="countryId"
                      >
                        <el-select
                          v-model="form.countryId"
                          :placeholder="item.placeholder"
                          :disabled="!item.editable"
                          filterable
                          @change="fetchProvinceList"
                        >
                          <el-option
                            v-for="c in countryList"
                            :key="c.id"
                            :value="parseInt(c.id)"
                            :label="c.name"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item
                        :label="item.name"
                        v-if="item.keyword == 'provinceName'"
                        prop="provinceId"
                      >
                        <el-select
                          v-model="form.provinceId"
                          :placeholder="item.placeholder"
                          :disabled="!item.editable"
                          filterable
                          @change="fetchCityList"
                        >
                          <el-option
                            v-for="p in provinceList"
                            :key="p.id"
                            :value="parseInt(p.id)"
                            :label="p.name"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item
                        :label="item.name"
                        v-if="item.keyword == 'cityName'"
                        prop="cityId"
                      >
                        <el-select
                          v-model="form.cityId"
                          :placeholder="item.placeholder"
                          :disabled="!item.editable"
                          @change="changeCity"
                          filterable
                        >
                          <el-option
                            v-for="c in cityList"
                            :key="c.id"
                            :value="parseInt(c.id)"
                            :label="c.name"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </template>
                  </el-col>
                </div>
              </template>
            </template>
            <div class="v-line"></div>
            <!-- 字段2组 -->
            <template v-for="(item) in list">
              <template v-if="fields2.indexOf(item.keyword) > -1">
                <div :key="item.id">
                  <el-col :xs="24" :sm="24" :md="24" v-if="$config.form.textareaFields.indexOf(item.keyword) > -1">
                    <el-form-item
                      :label="item.name"
                      :prop="item.keyword">
                      <el-input
                        type="textarea"
                        rows="4"
                        :placeholder="item.placeholder"
                        :disabled="!item.editable"
                        v-model="form[item.keyword]"
                        :maxlength="item.inputLength || 200"
                        show-word-limit
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col v-else :xs="24" :sm="12" :md="12">
                    <el-form-item
                      :label="item.name"
                      v-if="uploadText.indexOf(item.keyword) == -1 && countryArea.indexOf(item.keyword) == -1"
                      :prop="item.keyword">
                      <template v-if="item.canSelect">
                        <el-select
                          v-if="item.keyword == 'listed'"
                          v-model="form[item.keyword]"
                          :placeholder="item.placeholder"
                          :disabled="!item.editable"
                        >
                          <el-option v-for="item in listedList" :value="item.value" :label="item.label" :key="item.value"></el-option>
                        </el-select>
                        <el-select
                          v-else
                          v-model="form[item.keyword]"
                          :disabled="!item.editable"
                          :placeholder="item.placeholder"
                        ></el-select>
                      </template>
                      <template v-if="!item.canSelect">
                        <el-input
                          :placeholder="item.placeholder"
                          :disabled="!item.editable"
                          v-model="form[item.keyword]"
                          :maxlength="item.inputLength || 200"
                          :class="{'input-with-select': $config.form.httpFields.indexOf(item.keyword) > -1}"
                          show-word-limit>
                          <el-select v-model="form[item.keyword+'_http']" slot="prepend" v-if="$config.form.httpFields.indexOf(item.keyword) > -1">
                            <el-option v-for="item in $t('select.httpOptions')" :key="item.label" :value="item.value"></el-option>
                          </el-select>
                          <template slot="prepend" v-if="$config.form.phoneCodeFields.indexOf(item.keyword) > -1 && form.countryCode">{{form.countryCode}}</template>
                          <template slot="prepend" v-if="$config.form.cityPhoneCodeFields.indexOf(item.keyword) > -1 && phoneCode"> - </template>
                          <template slot="prepend" v-if="$config.form.cityPhoneCodeFields.indexOf(item.keyword) > -1 && phoneCode">{{phoneCode}}</template>
                        </el-input>
                      </template>
                    </el-form-item>
                    <template v-if="uploadText.indexOf(item.keyword) == -1">
                      <el-form-item
                        :label="item.name"
                        v-if="item.keyword == 'countryName'"
                        prop="countryId"
                      >
                        <el-select
                          v-model="form.countryId"
                          :placeholder="item.placeholder"
                          :disabled="!item.editable"
                          filterable
                          @change="fetchProvinceList"
                        >
                          <el-option
                            v-for="c in countryList"
                            :key="c.id"
                            :value="parseInt(c.id)"
                            :label="c.name"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item
                        :label="item.name"
                        v-if="item.keyword == 'provinceName'"
                        prop="provinceId"
                      >
                        <el-select
                          v-model="form.provinceId"
                          :placeholder="item.placeholder"
                          :disabled="!item.editable"
                          filterable
                          @change="fetchCityList"
                        >
                          <el-option
                            v-for="p in provinceList"
                            :key="p.id"
                            :value="parseInt(p.id)"
                            :label="p.name"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item
                        :label="item.name"
                        v-if="item.keyword == 'cityName'"
                        prop="cityId"
                      >
                        <el-select
                          v-model="form.cityId"
                          :placeholder="item.placeholder"
                          :disabled="!item.editable"
                          @change="changeCity"
                          filterable
                        >
                          <el-option
                            v-for="c in cityList"
                            :key="c.id"
                            :value="parseInt(c.id)"
                            :label="c.name"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </template>
                  </el-col>
                </div>
              </template>
            </template>
            <div class="v-line"></div>
            <!-- 字段3组 -->
            <template v-for="(item) in list">
              <template v-if="fields3.indexOf(item.keyword) > -1">
                <div :key="item.id">
                  <el-col :xs="24" :sm="24" :md="24" v-if="$config.form.textareaFields.indexOf(item.keyword) > -1">
                    <el-form-item
                      :label="item.name"
                      :prop="item.keyword">
                      <el-input
                        type="textarea"
                        rows="4"
                        :placeholder="item.placeholder"
                        :disabled="!item.editable"
                        v-model="form[item.keyword]"
                        :maxlength="item.inputLength || 200"
                        show-word-limit
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col v-else :xs="24" :sm="12" :md="12">
                    <el-form-item
                      :label="item.name"
                      v-if="uploadText.indexOf(item.keyword) == -1 && countryArea.indexOf(item.keyword) == -1"
                      :prop="item.keyword">
                      <template v-if="item.canSelect">
                        <el-select
                          v-if="item.keyword == 'listed'"
                          v-model="form[item.keyword]"
                          :placeholder="item.placeholder"
                          :disabled="!item.editable"
                        >
                          <el-option v-for="item in listedList" :value="item.value" :label="item.label" :key="item.value"></el-option>
                        </el-select>
                        <el-select
                          v-else
                          v-model="form[item.keyword]"
                          :disabled="!item.editable"
                          :placeholder="item.placeholder"
                        ></el-select>
                      </template>
                      <template v-if="!item.canSelect">
                        <el-input
                          :placeholder="item.placeholder"
                          :disabled="!item.editable"
                          v-model="form[item.keyword]"
                          :maxlength="item.inputLength || 200"
                          :class="{'input-with-select': $config.form.httpFields.indexOf(item.keyword) > -1}"
                          show-word-limit>
                          <el-select v-model="form[item.keyword+'_http']" slot="prepend" v-if="$config.form.httpFields.indexOf(item.keyword) > -1">
                            <el-option v-for="item in $t('select.httpOptions')" :key="item.label" :value="item.value"></el-option>
                          </el-select>
                          <template slot="prepend" v-if="$config.form.phoneCodeFields.indexOf(item.keyword) > -1 && form.countryCode">{{form.countryCode}}</template>
                          <template slot="prepend" v-if="$config.form.cityPhoneCodeFields.indexOf(item.keyword) > -1 && phoneCode"> - </template>
                          <template slot="prepend" v-if="$config.form.cityPhoneCodeFields.indexOf(item.keyword) > -1 && phoneCode">{{phoneCode}}</template>
                        </el-input>
                      </template>
                    </el-form-item>
                    <template v-if="uploadText.indexOf(item.keyword) == -1">
                      <el-form-item
                        :label="item.name"
                        v-if="item.keyword == 'countryName'"
                        prop="countryId"
                      >
                        <el-select
                          v-model="form.countryId"
                          :placeholder="item.placeholder"
                          :disabled="!item.editable"
                          filterable
                          @change="fetchProvinceList"
                        >
                          <el-option
                            v-for="c in countryList"
                            :key="c.id"
                            :value="parseInt(c.id)"
                            :label="c.name"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item
                        :label="item.name"
                        v-if="item.keyword == 'provinceName'"
                        prop="provinceId"
                      >
                        <el-select
                          v-model="form.provinceId"
                          :placeholder="item.placeholder"
                          :disabled="!item.editable"
                          filterable
                          @change="fetchCityList"
                        >
                          <el-option
                            v-for="p in provinceList"
                            :key="p.id"
                            :value="parseInt(p.id)"
                            :label="p.name"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item
                        :label="item.name"
                        v-if="item.keyword == 'cityName'"
                        prop="cityId"
                      >
                        <el-select
                          v-model="form.cityId"
                          :placeholder="item.placeholder"
                          :disabled="!item.editable"
                          @change="changeCity"
                          filterable
                        >
                          <el-option
                            v-for="c in cityList"
                            :key="c.id"
                            :value="parseInt(c.id)"
                            :label="c.name"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </template>
                  </el-col>
                </div>
              </template>
            </template>
          </div>
        </el-row>
      </el-form>
      <div class="form-submit-block" v-if="companyInfo">
        <el-button
          :loading="loading"
          class="dash-submit btn-544"
          @click="submitForm('companyForm')"
          type="primary"
          >{{ $t('Confirm and publish') }}</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import {
  getExhibitorBaseInfo,
  getFetchList,
  updateExhibitorInfo,
  fetchCountry,
  fetchProvince,
  fetchCity
} from '@/api/index'
import { validateFn, validImagesLength } from '@/utils/validate'
import DashUploadMore from '@/components/DashUploadMore'

import companyTips1 from '../../assets/images/company/1.png'
import companyTips2 from '../../assets/images/company/2.png'
import companyTips3 from '../../assets/images/company/3.png'
import companyTips4 from '../../assets/images/company/4.png'
import companyTips5 from '../../assets/images/company/5.png'
import tips   from '../../assets/images/tips.png'
import tipsEn from '../../assets/images/tipsEn.png'
import logo from '../../assets/images/eLogo.png'


export default {
  name: 'ExhibitForm',
  data() {
    return {
      imgList: {
        companyTips1,
        companyTips2,
        companyTips3,
        companyTips4,
        companyTips5,
        tips,
        tipsEn,
        logo
      },
      uploadFileStatus: 1,
      loading: false,
      // 上传字段key
      uploadText: ['logoImage', 'advertsImage', 'advertsVideo'],
      // 国家省份城市
      countryArea: ['countryName', 'provinceName', 'cityName'],
      // 字段1
      fields1: ['name', 'enName', 'introduction', 'enIntroduction'],
      // 字段2
      fields2: ['countryName', 'provinceName', 'cityName', 'address', 'enAddress', 'telephone', 'zipCode', 'webUrl',
      'fax', 'email'],
      // 字段3
      fields3: ['brand', 'registeredCapital', 'identificationNumber', 'listed', 'certification', 'url3d', 'linkName', 'linkMobile', 'linkEmail', 'linkName1', 'linkMobile1', 'linkEmail1'],
      init: false,
      list: [],
      uploadList: [],
      form: {
        advertsVideoImage: [],
        advertsVideo: [],
        countryCode: '',
        webUrl_http: 'http://',
        url3d_http: 'http://'
      },
      rules: {},
      // 国家字典
      countryList: [],
      // 省份字典
      provinceList: [],
      // 城市字典
      cityList: [],
      // 区号 根据城市而定
      phoneCode: '',
      // 国家号 根据国家而定
      countryCode: '',
      // 是否上市字典
      listedList: [{
        label: this.$t('Yes'),
        value: true
      },{
        label: this.$t('No'),
        value: false
      }],
      companyInfo: false
    }
  },
  components: {
    DashUploadMore
  },
  computed: {
    ...mapGetters(['language', 'info']),
    noAdmin() {
      return !this.info || (this.info && !this.info.exhibitorEmployee) || (this.info && this.info.exhibitorEmployee && !this.info.exhibitorEmployee.admin)
    }
  },
  watch: {
    'form.cityId': function(value) {
      if(value == '') {
        this.phoneCode = ''
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if(vm.noAdmin) {
        vm.$router.replace('/')
      }
    })
  },
  mounted() {
    if(!this.noAdmin) {
      this.getFetchList()
      this.fetchCountryList()
    }
  },
  methods: {
    // 图片上传功能（照片，视频，封面图）
    uploadFile(name, status) {
      if (status !== undefined) {
        this.uploadFileStatus = status
      }

      if ((status === 1 && this.form['advertsVideo'].length == 1) || (status === 2 && this.form['advertsVideoImage'].length == 1)) {
        return
      }

      this.$nextTick(() => {
        this.$refs[name][0].uploadAdd()
      })
    },
    // 获取公司详情（展商）
    fetchInfo() {
      getExhibitorBaseInfo({
        id: this.$store.getters.exhibitorId
      })
        .then(res => {
          return res.data
        })
        .then(res => {
          if (res.code === 1000) {
            let info = res.data
            for (let item in info) {
              if (item === 'advertsImage') {
                let imgs = info[item] ? info[item].split(',') : []
                this.form[item] = imgs
              } else {
                if (typeof info[item] === 'boolean') {
                  this.form[item] = info[item]
                } else {
                  this.form[item] = info[item]
                }
              }

              // 网址 回显
              if (this.$config.form.httpFields.indexOf(item) > -1) {
                let info = this.form[item]
                if (info && info.indexOf("http://") == 0) {
                  this.form[item] = this.form[item].substr(7)
                  this.form[item+"_http"] = 'http://'
                } else if (info && info.indexOf("https://") == 0) {
                  this.form[item] = this.form[item].substr(8)
                  this.form[item+"_http"] = 'https://'
                } else {
                  this.form[item+"_http"] = 'http://'
                }
              }
            }

            if (this.form.countryId) {
              this.fetchProvinceList(this.form.countryId, true)
            }
            if (this.form.provinceId) {
              this.fetchCityList(this.form.provinceId, true)
            }
            if (this.form.telephone && this.form.telephone.split("-").length >= 2) {
              let data = this.form.telephone.split("-")
              this.phoneCode = data.shift()
              this.form.telephone = data.join("-")
            }
            if (this.form.fax && this.form.fax.split("-").length >= 2) {
              let data = this.form.fax.split("-")
              this.phoneCode = data.shift()
              this.form.fax = data.join("-")
            }

            this.form.advertsVideo = info.advertsVideo ? info.advertsVideo.split(',') : []
            this.form.advertsVideoImage = info.advertsVideoImage ? info.advertsVideoImage.split(',') : []
            this.form.logoImage = info.logoImage ? info.logoImage.split(',') : []
          }
        }).finally(() => {
          this.companyInfo = true
        })
    },
    // 获取form表单字段
    getFetchList() {
      const loading = this.$loading()
      getFetchList()
        .then(res => {
          return res.data
        })
        .then(res => {
          if (res.code === 1000) {
            if (res.data.formFieldList.length > 0) {
              // 上传字段
              res.data.formFieldList.forEach(item => {
                if (this.uploadText.indexOf(item.keyword) > -1) {
                  this.uploadList.push(item)
                }
              })
              // 非上传字段
              let list = []
              res.data.formFieldList.forEach(item => {
                if (this.uploadText.indexOf(item.keyword) == -1) {
                  list.push(item)
                }
              })
              /**
               * 给form赋值
               * 生成验证规则
               */
              res.data.formFieldList.forEach(item => {
                switch (item.keyword) {
                  case 'provinceName':
                    this.$set(this.form, 'provinceId', '')
                    break
                  case 'countryName':
                    this.$set(this.form, 'countryId', '')
                    break
                  case 'cityName':
                    this.$set(this.form, 'cityId', '')
                    break
                  case 'advertsImage':
                    this.$set(this.form, item.keyword, ['', '', ''])
                    break
                  default:
                    this.$set(this.form, item.keyword, '')
                }

                // 必填条件
                if (item.required) {
                  let field = ''
                  if (!this.rules[item.keyword]) {
                    field = this.changeField(item.keyword) || item.keyword
                    this.$set(this.rules, field, [])
                  }

                  if (item.keyword === 'advertsImage') {
                    this.rules[item.keyword].push({
                      validator: validateFn(validImagesLength),
                      message: this.$t('Please upload at least one picture'),
                      trigger: 'change'
                    })
                  } else {
                    this.rules[field].push({
                      required: true,
                      message: item.name + ' ' + this.$t('common.required'),
                      trigger: 'change'
                    })
                  }
                }
              })
              this.list = list
              return true
            }
          }
        })
        .then(() => {
          this.init = true
          //获取公司信息
          this.fetchInfo()
        })
        .finally(() => {
          setTimeout(() => {
            loading.close()
          }, 500)
        })
    },
    // 把国家，省份，城市的字段转换一下
    changeField(field) {
      let t = ''
      switch (field) {
        case 'countryName':
          t = 'countryId'
          break
        case 'provinceName':
          t = 'provinceId'
          break
        case 'cityName':
          t = 'cityId'
          break
      }
      return t
    },
    // 获取表单提交的字段值
    getFormData() {
      let data = JSON.parse(JSON.stringify(this.form))
      data.advertsImage = data.advertsImage.filter(item => {
        return item != ''
      })
      data.advertsImage = data.advertsImage.join(',')

      const c = (d) => {
        return this.phoneCode ? [this.phoneCode, d].join('-') : d
      }

      for(let key in data) {
        if (['advertsVideo', 'advertsVideoImage', 'logoImage'].includes(key)) {
          if (data[key].length == 0) {
            data[key] = ''
          } else {
            data[key] = data[key].join(',')
          }
        }

        if (this.$config.form.httpFields.indexOf(key) > -1) {
          if (data[key]) {
            data[key] = this.form[key+'_http'] + data[key]
          } else {
            data[key] = ''
          }
        }

        if (this.$config.form.cityPhoneCodeFields.indexOf(key) > -1 && data[key]) {
          data[key] = c(data[key])
        }
      }
      return data
    },
    // 提交
    submitForm(formName) {
      if(this.form.advertsVideoImage.length == 0 && this.form.advertsVideo.length != 0) {
        this.$notify({
          message: this.$t('Please upload a cover image of the video while uploading the video. Otherwise the front-end display will be blank.'),
          type: 'warning'
        });
        return false
      }
      if(this.form.advertsVideoImage.length != 0 && this.form.advertsVideo.length == 0) {
        this.$notify({
          message: this.$t('Please upload Video.'),
          type: 'warning'
        });
        return false
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          const loading = this.$loading()
          this.loading = true
          updateExhibitorInfo(this.getFormData())
            .then(res => {
              return res.data
            })
            .then(res => {
              if (res.code === 1000) {
                // this.$router.replace('/company-management')
                this.$notify({
                  title: this.$t('tip.success'),
                  message: this.$t('Revise Success'),
                  type: 'success'
                });
              }
            })
            .finally(() => {
              loading.close()
              this.loading = false
            })
        } else {
          return false
        }
      })
    },
    unique5(arr) {
      let a = []
      let b = []
      arr.forEach(item => {
        if (a.indexOf(item.id) == -1) {
          a.push(item.id)
          b.push(item)
        }
      })
      return b
    },
    // 获取国家列表
    fetchCountryList() {
      this.provinceList = []
      this.cityList = []
      this.$set(this.form, 'provinceId', '')
      this.$set(this.form, 'cityId', '')
      fetchCountry()
        .then(res => {
          return res.data
        })
        .then(res => {
          if (res.code === 1000) {
            this.countryList = this.unique5(res.data)
          }
        })
    },
    // 获取省份列表
    fetchProvinceList(id, status) {
      if (!status) {
        this.provinceList = []
        this.cityList = []
        this.$set(this.form, 'provinceId', '')
        this.$set(this.form, 'cityId', '')
      }
      window.PC.findItem(() => {
        return this.countryList
      }, 'id', id, 'phoneCode', (val) => {
        this.form.countryCode = parseInt(val)
      })
      fetchProvince({
        countryId: id
      })
        .then(res => {
          return res.data
        })
        .then(res => {
          if (res.code === 1000) {
            this.provinceList = res.data
          }
        })
    },
    // 获取城市列表
    fetchCityList(id, status) {
      if (!status) {
        this.cityList = []
        this.$set(this.form, 'cityId', '')
      }
      fetchCity({ provinceId: id })
        .then(res => {
          return res.data
        })
        .then(res => {
          this.cityList = res.data
          if(this.form['cityId']) {
            this.changeCity(this.form['cityId'])
          }
          this.$forceUpdate()
        })
    },
    // 城市
    changeCity(value){
      window.PC.findItem(() => {
        return this.cityList
      }, 'id', value, 'phoneCode', (val) => {
        this.phoneCode = val
      })
    },
  }
}
</script>

<style lang="stylus" scoped>
.dash-form-container {
  padding: 0px;
  padding-bottom: 60px;
  margin-top: 30px;
  background: $color-white;
}

.form-block {
  background: $color-gray-fb;
  padding: 24px 15px;
  margin-bottom: 15px;
}

.icondiv{
  width 910px
  min-height 234px;

  .iconTips {
    img {
      width 300px
      height 140px
    }
  }

  &.video {
    width: 435px;
    min-height: 220px;

    .iconTips {
      margin-right: 0
      img {
        width 401px
        height 187px
      }
    }
  }

  &.iconLogo {
    width: 219px;
    min-height: 219px;

    .iconTips {
      margin-right: 0
      img {
        width 187px
        height 187px
      }
    }
  }
}

</style>
